import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { canUndoRedoSelector, redoAction, undoAction } from "@skilitics/nautilus-core-designer-data";

export const useUndoRedo = () => {
  const { canUndo, canRedo } = useSelector(canUndoRedoSelector);
  const dispatch = useDispatch();

  const undo = useCallback(() => {
    dispatch(undoAction());
  }, [dispatch]);

  const redo = useCallback(() => {
    dispatch(redoAction());
  }, [dispatch]);

  return useMemo(
    () => ({
      canUndo,
      canRedo,
      undo,
      redo,
    }),
    [canRedo, canUndo, redo, undo],
  );
};
